<template>
  <hr class="divider">
</template>

<script>
export default {
name: 'm-divider',
}
</script>

<style lang="scss" scoped>
.divider {
  border-top: 1px solid var(--another-grey);
}
</style>